module.exports = __webpack_public_path__ + "static/media/JE_WEB_DEV_RESUME.b143abe0.pdf";